// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6964) return "static/chunks/6964-116079346dc10d27.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7792 ? "booking-modal" : chunkId) + "." + {"2934":"1ffa720aa13997c7","7792":"7489ff42b3efa8ba"}[chunkId] + ".js";
};